import FormX from 'sb-formx'
import { required, streetAddress, maxLength, zipCode, userNameValidation, minLength,
  cardNumber, expDate, cardCVV, telephone, nonMilitaryZipCode, nonMilitaryState } from 'helpers/validation'
import getCookieValue from 'helpers/getCookieValue'

import { StateShortName } from 'common/helpers/getters/getUsaStates'


const isDebug = Boolean(getCookieValue('debug', true))


export type ShippingType = {
  apt: string
  city: string
  street: string
  zipCode: string
  lastName: string
  firstName: string
  telephone?: string
  state: StateShortName
  country: 'United States'
}

export type CreditCardType = {
  cardNumber: string
  holderName: string
  zipCode: string
  expDate:string
  cvc: string
}

const shippingForm: any = new FormX({
  fields: {
    firstName: [ required, userNameValidation, maxLength(100) ],
    lastName: [ required, userNameValidation, maxLength(100) ],
    street: [ required, streetAddress ],
    apt: [],
    zipCode: [ required, zipCode, nonMilitaryZipCode ],
    city: [ required, minLength(3) ],
    state: [ required, nonMilitaryState ],
    country: {
      validate: [ required ],
      value: 'United States',
      readOnly: true, // TODO add "readOnly" support to FormX
    },
    telephone: [ telephone ],
  },
  initialValues: !isDebug ? {} : {
    firstName: 'John',
    lastName: 'Doe',
    street: '1218 5th Avenue ',
    apt: '3',
    zipCode: '10029',
    city: 'New York',
    state: 'NY',
  },
})

const creditCardForm = new FormX({
  fields: {
    cardNumber: [ required, cardNumber ],
    holderName: [ required ],
    expDate: [ required, expDate ],
    cvc: [ required, cardCVV ],
    zipCode: [ required, zipCode ],
  },
  initialValues: !isDebug ? {} : {
    cardNumber: '4242424242424242',
    holderName: 'John Doe',
    expDate: '11/22',
    cvc: '088',
    zipCode: '10095',
  },
})

const couponForm = new FormX({
  fields: {
    code: [],
  },
})


const getIsShippingFormValid = () => {
  try {
    const value = localStorage.getItem('formShippingIsValid')

    return value ? JSON.parse(value) : false
  }
  catch (err) {
    return false
  }
}

const setIsShippingFormValid = (value) => {
  try {
    localStorage.setItem('formShippingIsValid', JSON.stringify(value))
  }
  catch (err) {
    console.error('localStorage error', err)
  }
}


export {
  shippingForm,
  creditCardForm,
  couponForm,

  getIsShippingFormValid,
  setIsShippingFormValid,
}
